<template>
  <div class="kplay-container">
    <div class="kplay-header" v-if="!gameUrl">
      <h2 class="kplay-title">슬롯 게임</h2>
      <div class="kplay-filter">
        <button
          v-for="vendor in vendors"
          :key="vendor.id"
          :class="['filter-btn', { active: selectedVendor === vendor.id }]"
          @click="selectedVendor = vendor.id"
        >
          {{ vendor.name }}
        </button>
      </div>
      <div class="kplay-search">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="게임 검색..."
          class="search-input"
        />
      </div>
    </div>

    <div class="games-grid" v-if="!gameUrl">
      <div
        v-for="game in filteredGames"
        :key="game.product_id"
        class="game-card"
        @click="openGame(game)"
      >
        <div class="game-thumbnail">
          <img :src="game.img || getGameImage(game.product_id)" :alt="game.name" @error="handleImageError($event, game.product_id)" />
          <div class="game-name-overlay">{{ game.name }}</div>
          <div class="game-overlay">
            <button class="play-btn">플레이</button>
          </div>
        </div>
        <div class="game-info">
          <h3 class="game-name">{{ game.name }}</h3>
          <span class="game-vendor">{{ game.vendor }}</span>
        </div>
      </div>
    </div>

    <div v-if="filteredGames.length === 0 && !gameUrl" class="no-games">
      검색 결과가 없습니다.
    </div>

    <!-- Game Iframe -->
    <div v-if="gameUrl" class="game-iframe-container">
      <div class="game-iframe-header">
        <span class="game-title">{{ currentGameName }}</span>
        <button class="close-btn" @click="closeGame">✕ 닫기</button>
      </div>
      <iframe
        :src="gameUrl"
        class="game-iframe"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "KplaySlot",
  data() {
    return {
      searchQuery: '',
      selectedVendor: 'all',
      gameUrl: null,
      currentGameName: '',
      vendors: [
        { id: 'all', name: '전체' },
        { id: 'Pragmatic', name: '프라그마틱' },
        { id: 'Habanero', name: '하바네로' },
        { id: 'PG Soft', name: 'PG소프트' },
        { id: 'CQ9', name: 'CQ9' },
        { id: 'Netent', name: '넷엔트' },
        { id: 'Micro', name: '마이크로' },
        { id: 'Play n Go', name: '플레이앤고' },
      ],
      games: [
        { product_id: 200, name: '프라그마틱플레이', vendor: 'Pragmatic', img: require('@/assets/img/slot/pragmatic.png') },
        { product_id: 201, name: '하바네로', vendor: 'Habanero', img: require('@/assets/img/slot/habanero.png') },
        { product_id: 202, name: '엘리시움', vendor: 'Elysium', img: require('@/assets/img/slot/elysium.png') },
        { product_id: 204, name: '퀵스핀', vendor: 'Quickspin', img: require('@/assets/img/slot/quickspin.png') },
        { product_id: 205, name: '스페이드 게이밍', vendor: 'Spade', img: require('@/assets/img/slot/spade.png') },
        { product_id: 207, name: '플레이앤고', vendor: 'Play n Go', img: require('@/assets/img/slot/playandgo.png') },
        { product_id: 208, name: '월드매치', vendor: 'World Match', img: require('@/assets/img/slot/worldmatch.png') },
        { product_id: 209, name: '마이크로게이밍', vendor: 'Micro', img: require('@/assets/img/slot/microgaming.png') },
        { product_id: 213, name: 'EVO 레드타이거', vendor: 'Red Tiger', img: require('@/assets/img/slot/evoredtiger.png') },
        { product_id: 214, name: '넷엔트', vendor: 'Netent', img: require('@/assets/img/slot/netent.png') },
        { product_id: 215, name: '드래곤소프트', vendor: 'Dragon Soft', img: require('@/assets/img/slot/dragonsoft.png') },
        { product_id: 216, name: 'YGG드라실', vendor: 'Yggdrasil', img: require('@/assets/img/slot/ygg.png') },
        { product_id: 217, name: '분고', vendor: 'Bungo', img: require('@/assets/img/slot/boongo.png') },
        { product_id: 219, name: '플레이텍', vendor: 'Playtech', img: require('@/assets/img/slot/playtech.png') },
        { product_id: 220, name: 'CQ9', vendor: 'CQ9', img: require('@/assets/img/slot/cq9.png') },
        { product_id: 221, name: '스카이윈드', vendor: 'Skywind', img: require('@/assets/img/slot/skywind.jpg') },
        { product_id: 222, name: '와즈단', vendor: 'Wazdan', img: require('@/assets/img/slot/wazdan.jpg') },
        { product_id: 223, name: 'PG소프트', vendor: 'PG Soft', img: require('@/assets/img/slot/pocketgames.png') },
        { product_id: 224, name: '로얄슬롯 게이밍', vendor: 'Royal', img: require('@/assets/img/slot/royal.png') },
        { product_id: 225, name: 'EVO 빅타임', vendor: 'Big Time', img: require('@/assets/img/slot/evo-big.png') },
        { product_id: 227, name: 'EVO 노리밋', vendor: 'No Limit', img: require('@/assets/img/slot/evo-nolimit.png') },
        { product_id: 228, name: 'CC88', vendor: 'CC88', img: require('@/assets/img/slot/CC88.png') },
        { product_id: 229, name: '릴랙스 게이밍', vendor: 'Relax', img: require('@/assets/img/slot/relax.png') },
        { product_id: 230, name: '패스트스핀', vendor: 'Fast Spin', img: require('@/assets/img/slot/fastspin.png') },
        { product_id: 231, name: '넥스트스핀', vendor: 'Next Spin', img: require('@/assets/img/slot/nextspin.jpg') },
        { product_id: 235, name: '플레이스타', vendor: 'Play Star', img: require('@/assets/img/slot/playstar.png') },
        { product_id: 246, name: '노보매틱', vendor: 'Novomatic', img: require('@/assets/img/slot/novomatic.png') },
        { product_id: 249, name: '나가게임즈', vendor: 'Naga', img: require('@/assets/img/slot/naga.png') },
        { product_id: 250, name: '히든버튼', vendor: 'Hidden', img: require('@/assets/img/slot/hidden.png') },
        { product_id: 253, name: '슬롯밀', vendor: 'Slot Mill', img: require('@/assets/img/slot/slotmill.png') },
        { product_id: 254, name: '피터앤슨', vendor: 'Peter', img: require('@/assets/img/slot/peterandson.png') },
        { product_id: 255, name: '핵쏘 게이밍', vendor: 'Hacksaw', img: require('@/assets/img/slot/hacksaw.png') },
        { product_id: 256, name: '아바타UX', vendor: 'AvatarUX', img: require('@/assets/img/slot/avartar_ux.png') },
        { product_id: 257, name: '586윈', vendor: '586Win', img: require('@/assets/img/slot/586win.png') },
        { product_id: 258, name: '블루프린트', vendor: 'Blueprint', img: require('@/assets/img/slot/blueprint_logo.png') },
        { product_id: 263, name: '지리게임즈', vendor: 'Jili', img: require('@/assets/img/slot/jili_logo.png') },
        { product_id: 265, name: 'JDB', vendor: 'JDB', img: require('@/assets/img/slot/jdb_logo.gif') },
        { product_id: 267, name: 'GPI', vendor: 'GPI', img: require('@/assets/img/slot/gpi_logo.png') },
        { product_id: 268, name: '킹미다스', vendor: 'King Midas', img: require('@/assets/img/slot/midas.png') },
        { product_id: 269, name: 'i게임', vendor: 'iGame', img: require('@/assets/img/slot/i-gaming.png') },
        { product_id: 279, name: '엔도르피나', vendor: 'Endorphina', img: require('@/assets/img/slot/endorpina.png') },
        { product_id: 286, name: '옥토플레이', vendor: 'Octoplay', img: require('@/assets/img/slot/octo.png') },
        { product_id: 295, name: '옐로배트', vendor: 'Yellow Bat', img: require('@/assets/img/slot/yello-bat.png') },
        { product_id: 297, name: '팻팬더', vendor: 'Fat Panda', img: require('@/assets/img/slot/pat-panda.png') },
        { product_id: 299, name: '플레이에이스', vendor: 'PlayAce', img: require('@/assets/img/slot/playace.png') },
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.page.isMobile;
    },
    filteredGames() {
      return this.games.filter(game => {
        const matchesVendor = this.selectedVendor === 'all' || game.vendor === this.selectedVendor;
        const matchesSearch = game.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                             game.vendor.toLowerCase().includes(this.searchQuery.toLowerCase());
        return matchesVendor && matchesSearch;
      });
    }
  },
  methods: {
    getGameImage(productId) {
      // Unsplash 무료 이미지 사용 (슬롯/카지노/게임 테마)
      const images = {
        200: 'https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=400&h=400&fit=crop', // 프라그마틱
        201: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=400&fit=crop', // 하바네로
        202: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d7?w=400&h=400&fit=crop', // 엘리시움
        204: 'https://images.unsplash.com/photo-1606167668584-78701c57f13d?w=400&h=400&fit=crop', // 퀵스핀
        205: 'https://images.unsplash.com/photo-1563941433-b6eb9aeda50a?w=400&h=400&fit=crop', // 스페이드
        207: 'https://images.unsplash.com/photo-1517232115160-ff93364542dd?w=400&h=400&fit=crop', // 플레이앤고
        208: 'https://images.unsplash.com/photo-1605870445919-838d190e8e1b?w=400&h=400&fit=crop', // 월드매치
        209: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=400&fit=crop', // 마이크로
        213: 'https://images.unsplash.com/photo-1493711662062-fa541f7f3d24?w=400&h=400&fit=crop', // 레드타이거
        214: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop', // 넷엔트
        215: 'https://images.unsplash.com/photo-1560253023-3ec5d502959f?w=400&h=400&fit=crop', // 드래곤소프트
        216: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400&h=400&fit=crop', // YGG
        217: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=400&h=400&fit=crop', // 분고
        219: 'https://images.unsplash.com/photo-1555680202-c86f0e12f086?w=400&h=400&fit=crop', // 플레이텍
        220: 'https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?w=400&h=400&fit=crop', // CQ9
        221: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=400&h=400&fit=crop', // 스카이윈드
        222: 'https://images.unsplash.com/photo-1553481187-be93c21490a9?w=400&h=400&fit=crop', // 와즈단
        223: 'https://images.unsplash.com/photo-1592155931584-901ac15763e3?w=400&h=400&fit=crop', // PG소프트
        224: 'https://images.unsplash.com/photo-1609710228159-0fa9bd7c0827?w=400&h=400&fit=crop', // 로얄슬롯
        225: 'https://images.unsplash.com/photo-1511882150382-421056c89033?w=400&h=400&fit=crop', // 빅타임
        227: 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=400&h=400&fit=crop', // 노리밋
        228: 'https://images.unsplash.com/photo-1585504198199-20277593b94f?w=400&h=400&fit=crop', // CC88
        229: 'https://images.unsplash.com/photo-1551103782-8ab07afd45c1?w=400&h=400&fit=crop', // 릴랙스
        230: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?w=400&h=400&fit=crop', // 패스트스핀
        231: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop', // 넥스트스핀
        235: 'https://images.unsplash.com/photo-1547394765-185e1e68f34e?w=400&h=400&fit=crop', // 플레이스타
        246: 'https://images.unsplash.com/photo-1570303345338-e1f0eddf4b68?w=400&h=400&fit=crop', // 노보매틱
        249: 'https://images.unsplash.com/photo-1493711662062-fa541f7f3d24?w=400&h=400&fit=crop', // 나가
        250: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop', // 히든버튼
        253: 'https://images.unsplash.com/photo-1614680376739-414d95ff43df?w=400&h=400&fit=crop', // 슬롯밀
        254: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop', // 피터앤슨
        255: 'https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?w=400&h=400&fit=crop', // 핵쏘
        256: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop', // 아바타UX
        257: 'https://images.unsplash.com/photo-1560253023-3ec5d502959f?w=400&h=400&fit=crop', // 568윈
        258: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d7?w=400&h=400&fit=crop', // 블루프린트
        263: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=400&fit=crop', // 지리
        265: 'https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=400&h=400&fit=crop', // JDB
        267: 'https://images.unsplash.com/photo-1606167668584-78701c57f13d?w=400&h=400&fit=crop', // GPI
        268: 'https://images.unsplash.com/photo-1563941433-b6eb9aeda50a?w=400&h=400&fit=crop', // 킹미다스
        269: 'https://images.unsplash.com/photo-1517232115160-ff93364542dd?w=400&h=400&fit=crop', // i게임
        279: 'https://images.unsplash.com/photo-1605870445919-838d190e8e1b?w=400&h=400&fit=crop', // 엔도르피나
        286: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=400&fit=crop', // 옥토플레이
        295: 'https://images.unsplash.com/photo-1493711662062-fa541f7f3d24?w=400&h=400&fit=crop', // 옐로배트
        297: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop', // 팻팬더
        299: 'https://images.unsplash.com/photo-1560253023-3ec5d502959f?w=400&h=400&fit=crop', // 플레이에이스
      };
      return images[productId] || `https://picsum.photos/seed/${productId}/400/400`;
    },
    handleImageError(e, productId) {
      e.target.src = `https://picsum.photos/seed/${productId}/400/400`;
    },
    async openGame(game) {
      if (!this.$store.state.user?.user) {
        return this.$store.dispatch('SHOW_ERR_MSG', '로그인이 필요합니다.');
      }

      try {
        const params = {
          domain_url: window.location.protocol + "//" + window.location.host + "/#/",
          product_id: 0,
          type: 0,
          filter: game.product_id,
          is_mobile: this.isMobile ? 1 : 0
        };

        const response = await this.$store.dispatch('GET_KPLAY_GAME', params);

        if (response.data && response.data.url) {
          window.open(
            response.data.url,
            'game_window',
            `width=${screen.width},height=${screen.height},left=0,top=0,scrollbars=yes,resizable=yes`
          );
        } else {
          this.$store.dispatch('SHOW_ERR_MSG', '게임을 불러올 수 없습니다.');
        }
      } catch (error) {
        console.error('Game launch error:', error);
        this.$store.dispatch('SHOW_ERR_MSG', '게임 실행 중 오류가 발생했습니다.');
      }
    },
    closeGame() {
      this.gameUrl = null;
      this.currentGameName = '';
    }
  }
};
</script>

<style scoped>
.kplay-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  /* background: #252b2b; */
}

.kplay-header {
  margin-bottom: 30px;
}

.kplay-title {
  color: #D4AF37;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.kplay-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.filter-btn {
  padding: 10px 20px;
  border: 1px solid #D4AF37;
  background: transparent;
  color: #D4AF37;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.filter-btn:hover,
.filter-btn.active {
  background: #D4AF37;
  color: #1a1a2e;
}

.kplay-search {
  display: flex;
  justify-content: center;
}

.search-input {
  width: 100%;
  max-width: 400px;
  padding: 12px 20px;
  border: 1px solid #3a4040;
  background: #1e2323;
  color: #fff;
  border-radius: 25px;
  font-size: 14px;
  outline: none;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.search-input:focus {
  border-color: #D4AF37;
  background: #1e2323;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.game-card {
  background: #1e2323;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #3a4040;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  border-color: #D4AF37;
}

.game-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 100%; /* 1:1 정사각형 */
  overflow: hidden;
}

.game-thumbnail img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.game-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
}

.game-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.game-card:hover .game-overlay {
  opacity: 1;
}

.play-btn {
  padding: 12px 30px;
  background: linear-gradient(135deg, #D4AF37 0%, #FFA500 100%);
  border: none;
  border-radius: 25px;
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.play-btn:hover {
  transform: scale(1.1);
}

.game-info {
  padding: 15px;
}

.game-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-vendor {
  color: #D4AF37;
  font-size: 12px;
}

.no-games {
  text-align: center;
  color: #999;
  padding: 50px;
  font-size: 18px;
}

/* Tablet: 3 columns */
@media (max-width: 1200px) {
  .games-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile: 2 columns */
@media (max-width: 768px) {
  .kplay-container {
    padding: 15px;
  }

  .kplay-title {
    font-size: 22px;
  }

  .games-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .filter-btn {
    padding: 8px 15px;
    font-size: 12px;
  }

  .game-info {
    padding: 10px;
  }

  .game-name {
    font-size: 12px;
  }

  .game-vendor {
    font-size: 10px;
  }
}

/* Small mobile: 2 columns */
@media (max-width: 480px) {
  .games-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .kplay-filter {
    gap: 6px;
  }

  .filter-btn {
    padding: 6px 12px;
    font-size: 11px;
  }

  .game-info {
    padding: 8px;
  }

  .game-name {
    font-size: 11px;
  }

  .game-vendor {
    font-size: 9px;
  }
}

/* Game Iframe Styles */
.game-iframe-container {
  width: 100%;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

.game-iframe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #1e2323;
  border-bottom: 1px solid #3a4040;
}

.game-title {
  color: #D4AF37;
  font-size: 18px;
  font-weight: 700;
}

.close-btn {
  padding: 10px 20px;
  background: #D4AF37;
  border: none;
  border-radius: 5px;
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: #FFEC8B;
}

.game-iframe {
  flex: 1;
  width: 100%;
  border: none;
  background: #000;
}

@media (max-width: 768px) {
  .game-iframe-container {
    height: calc(100vh - 80px);
  }

  .game-iframe-header {
    padding: 10px 15px;
  }

  .game-title {
    font-size: 14px;
  }

  .close-btn {
    padding: 8px 15px;
    font-size: 12px;
  }
}
</style>
